module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role_form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field01"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    attrs: {
      "type": "text",
      "id": "field01"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "field02"
    }
  }, [_vm._v("Тип")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.type),
      expression: "model.type"
    }],
    attrs: {
      "type": "text",
      "id": "field02",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.model.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "type", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d09c5670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin panel/forms/RoleForm.vue
// module id = 648
// module chunks = 0